import { CSSProperties } from 'react'

import styled, { css } from 'styled-components'

type InnerFlexboxProps = {
  flex?: Extract<CSSProperties['display'], 'flex' | 'inline-flex'>
  justifyContent?: CSSProperties['justifyContent']
  alignItems?: CSSProperties['alignItems']
  flexDirection?: CSSProperties['flexDirection']
  flexWrap?: CSSProperties['flexWrap']
  gap?: CSSProperties['gap']
  mt?: CSSProperties['marginTop']
  mb?: CSSProperties['marginBottom']
  $fullWidth?: boolean
}

type Props = InnerFlexboxProps & {
  sm?: FlexboxProps
  md?: FlexboxProps
  lg?: FlexboxProps
  xl?: FlexboxProps
}

export type FlexboxProps = Props

const getCss = ({
  flex,
  justifyContent,
  alignItems,
  flexDirection,
  flexWrap,
  gap,
  mt,
  mb,
  $fullWidth,
}: Props) => css`
  display: ${flex};
  justify-content: ${justifyContent};
  align-items: ${alignItems};
  flex-direction: ${flexDirection};
  flex-wrap: ${flexWrap};
  gap: ${gap};
  margin-top: ${mt};
  margin-bottom: ${mb};
  ${$fullWidth && 'width: 100%;'}
`

export const Flexbox = styled.div<Props>`
  ${({
    flex = 'flex',
    justifyContent = 'initial',
    alignItems = 'initial',
    flexDirection = 'initial',
    flexWrap = 'initial',
    gap = 'initial',
    mt = 'initial',
    mb = 'initial',
    ...rest
  }) =>
    getCss({
      flex,
      justifyContent,
      alignItems,
      flexDirection,
      flexWrap,
      gap,
      mt,
      mb,
      ...rest,
    })}

  ${({ sm, theme: { media } }) =>
    sm &&
    media.sm`
      ${getCss(sm)}
  `}

  ${({ md, theme: { media } }) =>
    md &&
    media.md`
      ${getCss(md)}
  `}

  ${({ lg, theme: { media } }) =>
    lg &&
    media.lg`
      ${getCss(lg)}
  `}

  ${({ xl, theme: { media } }) =>
    xl &&
    media.xl`
      ${getCss(xl)}
  `}
`
